import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {FormDataUpload, NestApiProvider} from '../nest-api';

@Injectable()
export class EmployeeCareerProvider {

  private _service: string = 'attendance';
  private _model: string = 'employeeCareer';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadTemplate(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadTemplate';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public uploadEmployeeCareer(file: File): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'uploadEmployeeCareer';
    const _params: FormDataUpload[] = [];
    _params.push({name: 'file', value: file});
    const _urlParams: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestUpload(_method, _url, _params);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/employee-career/employee-career.ts